import React from 'react';
import {Wrapper} from './style';

import { AUTH_BITHOLLA_FAVICON } from '../../config/media';

// import AuthLogo from './AuthLogo';

import PanelArray from './PanelArray';

const AuthWrapper = ({ children }) => {
	const num = parseInt((Math.random() * 100) % 10, 10) + 1;
	return (
		<Wrapper>
			{/* <AuthLogo /> */}
			<div className="auth-wrapper">
				<div className="auth-children">
					<div className="dash-logo">
						<img src={AUTH_BITHOLLA_FAVICON} alt="logo" />
					</div>
					<div className="auth-children-container">{children}</div>
					<div className="auth-footer">
						<span className="dash-line" />
						<p>
							Read HollaEx terms and conditions{' '}
							<a
								href="https://www.hollaex.com/terms-and-conditions"
								target="_blank"
								rel="noopener noreferrer"
							>
								here.
							</a>{' '}
							For the privacy policy&nbsp;
							<a
								href="https://www.hollaex.com/privacy-policy"
								target="_blank"
								rel="noopener noreferrer"
							>
								visit here.
							</a>
						</p>
					</div>
				</div>
			</div>
			<div className="bg-wrapper">
				<PanelArray num={num} />
			</div>
		</Wrapper>
	);
};

export default AuthWrapper;
